import {
  Button, Typography
} from "antd";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;

const EmailConfirmation = () => {
  const navigate = useNavigate();
  return (
    <div style={{ textAlign: "center" }}>
      <Title level={2} style={{ marginBottom: 0 }}>
        Grazie per esserti registrato!
      </Title>
      <Typography style={{ marginBottom: 43 }}>
        Ora puoi accedere alla tua area riservata
      </Typography>
      <Button type="primary" onClick={() => navigate("/app/login")}>Vai alla login</Button>
    </div>
  );
};

export default EmailConfirmation;
